import React, { ReactNode } from 'react';
import { colors } from '../../colors';
import { MinusIcon } from '../../icons/minusIcon';
import { PlusIconAccordion } from '../../icons/plusIcon';

interface CustomAccordionProps {
    title: ReactNode;
    expanded: boolean;
    onChange: () => void;
    children: ReactNode;
    id?: string;
    detailsClassName?: string;
    detailsStyle?: React.CSSProperties;
}

export function CustomAccordion({
    title,
    expanded,
    onChange,
    children,
    id,
    detailsClassName = "",
    detailsStyle
}: CustomAccordionProps) {
    return (
        <div
            id={id}
            className={`rounded-xl flex flex-col w-full shadow-sm ${expanded ? 'overflow-visible' : 'overflow-hidden'}`}
            style={{ border: `1px solid ${colors.brandPrimary[200]}` }}
        >
            <button
                type="button"
                onClick={onChange}
                className={`w-full flex items-center justify-between px-6 py-4 cursor-pointer outline-none border-none transition-colors rounded-t-xl ${expanded ? '' : 'rounded-b-xl'}`}
                style={{ backgroundColor: colors.brandPrimary[600] }}
                aria-expanded={expanded}
            >
                <div className="flex items-center text-white font-medium text-sm leading-4 uppercase tracking-wide">
                    {title}
                </div>
                <div
                    className="flex items-center justify-center text-white transition-transform duration-300 ease-in-out"
                    style={{ transform: expanded ? 'rotate(0deg)' : 'rotate(0deg)' }}
                >
                    <div className={`transition-all duration-300 ease-in-out ${expanded ? 'rotate-0 scale-100' : 'rotate-90 scale-90'}`}>
                        {expanded ? <MinusIcon /> : <PlusIconAccordion />}
                    </div>
                </div>
            </button>
            <div
                className="grid transition-all duration-500 ease-in-out rounded-b-xl"
                style={{
                    gridTemplateRows: expanded ? '1fr' : '0fr',
                    backgroundColor: colors.brandPrimary[100],
                }}
            >
                <div className={expanded ? 'overflow-visible' : 'overflow-hidden'}>
                    <div
                        className={`w-full transition-opacity duration-500 ease-in-out ${expanded ? 'opacity-100' : 'opacity-0'} ${detailsClassName}`}
                        style={{ padding: '24px', ...detailsStyle }}
                    >
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}